// extracted by mini-css-extract-plugin
module.exports = {"searchHorizontalRecosContainer":"kW","reco":"lW","products":"mW"};